import React, { useCallback } from 'react'
import SantanderLogo from '../../commons/Icons/SantanderLogoImg'
import ConsultorMais from '../../commons/Icons/ConsultorMais'
import appleImg from '../../commons/LandingSections/apple.svg'
import googleImg from '../../commons/LandingSections/google.svg'
import styles from './redirectToStores.module.scss'

export default function RedirectToStores() {
  const handleRedirectToPlayStore = useCallback(() => {
    setTimeout(() => {
      window.location =
        'https://play.google.com/store/apps/details?id=com.webmotors.consultormais'
    }, 25)
    window.location = 'consultormais://entry'
  }, [])

  const handleRedirectToApple = useCallback(() => {
    setTimeout(() => {
      window.location =
        'https://apps.apple.com/br/app/consultor-mais/id1545981967'
    }, 25)
    window.location = 'consultormais://consultormais/entry'
  }, [])

  return (
    <div className={styles.containerLading}>
      <div className={styles.header}>
        <h1>
          <SantanderLogo />
        </h1>
      </div>
      <section className={styles.content}>
        <div className={styles.logo}>
          <ConsultorMais />
        </div>

        <div>
          <h3 className={styles.subtitle}>
            Uma nova experiência de gestão comercial, crescimento dos seus
            ganhos e da presença Santander.
          </h3>
        </div>

        <div>
          <a
            href="#"
            onClick={handleRedirectToApple}
            style={{ marginRight: 15 }}
          >
            <img src={appleImg} alt="Apple Store" />
          </a>
          <a href="#" onClick={handleRedirectToPlayStore}>
            <img src={googleImg} alt=" Play Store" />
          </a>
        </div>
      </section>
    </div>
  )
}
